import { render, staticRenderFns } from "./ModalLoadingSubmit.vue?vue&type=template&id=4c5e9d12&"
import script from "./ModalLoadingSubmit.vue?vue&type=script&lang=js&"
export * from "./ModalLoadingSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports